//Core modules
import React from 'react';

//Custom modules
import {StepsProvider} from "./context/stepsContext";
import SubscriptionView from "./Subscription";

const Subscription = () => {

    return (
        <StepsProvider>
            <SubscriptionView />
        </StepsProvider>
    )
}

export default Subscription;